const CONSTANT = {
  STORAGE_KEY: {
    DRIVER_USER: 'driver-user',
    SAVED_URL: 'saved-url',
    MESSAGES: 'messages',
    CHAT_LABEL_FILTER: 'chat-label-filter',
    // Nhóm mở cuối theo từng tab chat_type — quay lại tab thì chọn lại + cuộn tới (17/10/2026).
    CHAT_LAST_GROUP: 'chat-last-group',
  },
  DATE_FORMAT: {
    LONG: 'DD/MM/YYYY HH:mm:ss',
    SHORT: 'DD/MM/YYYY',
    TIMEZONE: 'Asia/Ho_Chi_Minh',
    TIME: 'HH:mm',
  },
  SOCKET_EVENT: {
    MESSAGE_COUNT: 'message-count',
    NEW_MESSAGE: 'new-message',
    NEW_INSTANT: 'new-instant',
    NEW_OWNER_ASSIGNMENT: 'new-owner-assignment',
    NEW_MATCHING_OWNER: 'new-matching-owner',
    NEW_MATCHING_ORDER: 'new-matching-order',
    UPDATE_SUGGESTION: 'update-suggestion',
    UPDATE_MESSAGE: 'update-message',
    // Phải khớp với SOCKET_EVENTS.CHAT_GROUP_REMOVED ở backend (chat microservice).
    CHAT_GROUP_REMOVED: 'chat-group-removed',
    // Chính người dùng này vừa đánh dấu đã đọc ở một client khác (app nhân viên).
    // Phải khớp eventName trong notifyUnreadUpdated() ở chat/src/services/chat.service.js.
    UNREAD_UPDATED: 'unread-updated',
  },
  // Mã lỗi nghiệp vụ trả về từ backend; phải khớp với ERROR_CODES ở chat microservice.
  ERROR_CODE: {
    CHAT_GROUP_MEMBER_REMOVED: 'CHAT_GROUP_MEMBER_REMOVED',
  },
  MESSAGE: {
    CHAT_GROUP_MEMBER_REMOVED: 'Bạn không còn trong nhóm chat nữa.',
  },
  SYSTEM_ROLES: {
    QUAN_TRI_HE_THONG: 'QUẢN TRỊ HỆ THỐNG',
  },
  VIC_MENU_OPTIONS: {
    EXECUTE_THE_PLAN: 'EXECUTE THE PLAN',
  },
  KE_TOAN_CHUNG_TU_ROLES: {
    TRA_CUU_HOA_DON: 'TRA CỨU HÓA ĐƠN',
    QUET_VA_SO_SANH_TAI_LIEU: 'QUÉT VÀ SO SÁNH TÀI LIỆU',
  },
  EXECUTE_PLAN_ROLES: {
    CHECKLIST_XEM: 'XEM_CHECKLIST',
    CHECKLIST_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_CHECKLIST',
    CHECKLIST_TAO_TASK: 'TẠO TASK_CHECKLIST',
    CHECKLIST_TAO_HANG_MUC: 'TẠO HẠNG MỤC_CHECKLIST',
    CHECKLIST_CHINH_SUA: 'CHỈNH SỬA_CHECKLIST',
    DEV_IT_XEM: 'XEM_DEV IT',
    DEV_IT_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_DEV IT',
    DEV_IT_TAO_TASK: 'TẠO TASK_DEV IT',
    DEV_IT_TAO_HANG_MUC: 'TẠO HẠNG MỤC_DEV IT',
    DEV_IT_CHINH_SUA: 'CHỈNH SỬA_DEV IT',
    DEV_AI_XEM: 'XEM_DEV AI',
    DEV_AI_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_DEV AI',
    DEV_AI_TAO_TASK: 'TẠO TASK_DEV AI',
    DEV_AI_TAO_HANG_MUC: 'TẠO HẠNG MỤC_DEV AI',
    DEV_AI_CHINH_SUA: 'CHỈNH SỬA_DEV AI',
    MARKETING_XEM: 'XEM_MARKETING',
    MARKETING_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_MARKETING',
    MARKETING_TAO_TASK: 'TẠO TASK_MARKETING',
    MARKETING_TAO_HANG_MUC: 'TẠO HẠNG MỤC_MARKETING',
    MARKETING_CHINH_SUA: 'CHỈNH SỬA_MARKETING',
    QUAN_LY_XEM: 'XEM_QUẢN LÝ',
    QUAN_LY_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_QUẢN LÝ',
    QUAN_LY_TAO_TASK: 'TẠO TASK_QUẢN LÝ',
    QUAN_LY_TAO_HANG_MUC: 'TẠO HẠNG MỤC_QUẢN LÝ',
    QUAN_LY_CHINH_SUA: 'CHỈNH SỬA_QUẢN LÝ',
    TRANSPORT_XEM: 'XEM_TRANSPORT',
    TRANSPORT_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_TRANSPORT',
    TRANSPORT_TAO_TASK: 'TẠO TASK_TRANSPORT',
    TRANSPORT_TAO_HANG_MUC: 'TẠO HẠNG MỤC_TRANSPORT',
    TRANSPORT_CHINH_SUA: 'CHỈNH SỬA_TRANSPORT',
    TRUCKING_XEM: 'XEM_TRUCKING',
    TRUCKING_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_TRUCKING',
    TRUCKING_TAO_TASK: 'TẠO TASK_TRUCKING',
    TRUCKING_TAO_HANG_MUC: 'TẠO HẠNG MỤC_TRUCKING',
    TRUCKING_CHINH_SUA: 'CHỈNH SỬA_TRUCKING',
    TRUCKER_XEM: 'XEM_TRUCKER',
    TRUCKER_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_TRUCKER',
    TRUCKER_TAO_TASK: 'TẠO TASK_TRUCKER',
    TRUCKER_TAO_HANG_MUC: 'TẠO HẠNG MỤC_TRUCKER',
    TRUCKER_CHINH_SUA: 'CHỈNH SỬA_TRUCKER',
    SHIPPING_XEM: 'XEM_SHIPPING',
    SHIPPING_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_SHIPPING',
    SHIPPING_TAO_TASK: 'TẠO TASK_SHIPPING',
    SHIPPING_TAO_HANG_MUC: 'TẠO HẠNG MỤC_SHIPPING',
    SHIPPING_CHINH_SUA: 'CHỈNH SỬA_SHIPPING',
    HANG_GHEP_XEM: 'XEM_HÀNG GHÉP',
    HANG_GHEP_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_HÀNG GHÉP',
    HANG_GHEP_TAO_TASK: 'TẠO TASK_HÀNG GHÉP',
    HANG_GHEP_TAO_HANG_MUC: 'TẠO HẠNG MỤC_HÀNG GHÉP',
    HANG_GHEP_CHINH_SUA: 'CHỈNH SỬA_HÀNG GHÉP',
    CTV_XEM: 'XEM_CTV',
    CTV_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_CTV',
    CTV_TAO_TASK: 'TẠO TASK_CTV',
    CTV_TAO_HANG_MUC: 'TẠO HẠNG MỤC_CTV',
    CTV_CHINH_SUA: 'CHỈNH SỬA_CTV',
    PHAP_CHE_XEM: 'XEM_PHÁP CHẾ',
    PHAP_CHE_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_PHÁP CHẾ',
    PHAP_CHE_TAO_TASK: 'TẠO TASK_PHÁP CHẾ',
    PHAP_CHE_TAO_HANG_MUC: 'TẠO HẠNG MỤC_PHÁP CHẾ',
    PHAP_CHE_CHINH_SUA: 'CHỈNH SỬA_PHÁP CHẾ',
    KE_TOAN_XEM: 'XEM_KẾ TOÁN',
    KE_TOAN_CAI_DAT_NHAN_VIEN: 'CÀI ĐẶT NHÂN VIÊN_KẾ TOÁN',
    KE_TOAN_TAO_TASK: 'TẠO TASK_KẾ TOÁN',
    KE_TOAN_TAO_HANG_MUC: 'TẠO HẠNG MỤC_KẾ TOÁN',
    KE_TOAN_CHINH_SUA: 'CHỈNH SỬA_KẾ TOÁN',
  },
  COLOR_LABEL: {
    '#FF7473': 'Yêu cầu cập nhật tình hình xe',
    '#FFC6C6': 'Yêu cầu cập nhật tình hình chủ hàng',
    '#ED0000': 'Yêu cầu hỗ trợ',
    '#FECE3B': 'Yêu cầu cập nhật giờ nhận và giao hàng',
    '#FFFF00': 'Yêu cầu cập nhật xe rỗng',
    '#77E2FF': 'Chưa giao hàng',
    '#237ACB': 'Quá hạn thanh toán',
    '#91CF50': 'Chuyển tiền cho xe',
    '#975CCB': 'Thanh toán công ty',
    '#C642EB': 'Thanh toán công ty - Thu hộ',
    '#2E783A': 'Thanh toán công ty - Phí dịch vụ',
    '#909EE6': 'Thanh toán thu hộ',
    '#C188F6': 'Thanh toán phí dịch vụ',
    '#0808FF': 'Đang đợi duyệt HTĐH',
    '#2BC912': 'Chưa làm lệnh HTĐH',
    '#F87A1F': 'Nợ chứng từ',
  },
  // Vai trò trong chat_users.user_role — đồng bộ thủ công với chat/src/utils/constant.js và backend/src/utils/constant.js.
  CHAT_USER_ROLES: {
    MEMBER: 'member',
    MANAGER: 'manager',
  },
  // Tên hiện thay cho người gửi tin BẢO VỆ (nhóm đơn hàng) với người không được xem — khớp chat/src/utils/constant.js.
  TEN_NGUOI_GUI_TIN_BAO_VE_AN: 'NHÂN VIÊN VẬN HÀNH KHÁC',
  CHAT_ROLES: {
    TRUONG_NHOM: 'TRƯỞNG NHÓM',
    NGUOI_TAO_NHOM: 'NGƯỜI TẠO NHÓM',
    NHAN_VIEN_NHAN_VIEC: 'NHÂN VIÊN NHẬN VIỆC',
    NHAN_VIEN_DUOC_XEM: 'NHÂN VIÊN ĐƯỢC XEM',
    QUAN_LY_TRUC_TIEP: 'QUẢN LÝ TRỰC TIẾP',
    QUAN_LY_LIEN_DOI: 'QUẢN LÝ LIÊN ĐỚI',
    THANH_VIEN: 'THÀNH VIÊN',
    NHAN_VIEN_VIC: 'NHÂN VIÊN VIC',
    TAI_XE: 'TÀI XẾ',
    TAI_XE_VAN_HANH: 'TÀI XẾ VẬN HÀNH',
    TAI_XE_TRUONG_NHOM: 'TÀI XẾ TRƯỞNG NHÓM',
    CONG_TAC_VIEN: 'CỘNG TÁC VIÊN',
    NHAN_VIEN_HO_TRO_CTV_TRUC_TIEP: 'NHÂN VIÊN HỖ TRỢ CTV TRỰC TIẾP',
    NHAN_VIEN_HO_TRO_CTV_LIEN_DOI: 'NHÂN VIÊN HỖ TRỢ CTV LIÊN ĐỚI',
    NHAN_VIEN_HO_TRO_TRUC_TIEP: 'NHÂN VIÊN HỖ TRỢ TRỰC TIẾP',
    NHAN_VIEN_NHAN_HANG: 'NHÂN VIÊN NHẬN HÀNG',
    NHAN_VIEN_VAN_HANH: 'NHÂN VIÊN VẬN HÀNH',
    NHAN_VIEN_PHAN_VIEC: 'NHÂN VIÊN PHÂN VIỆC',
    NHAN_VIEN_TAO_DON: 'NHÂN VIÊN TẠO ĐƠN',
    QUAN_LY_VIC: 'QUẢN LÝ VIC',
    CTV_TRUONG_NHOM: 'CTV TRƯỞNG NHÓM',
    CTV_LIEN_DOI: 'CTV LIÊN ĐỚI',
    NHAN_VIEN_HO_TRO_LIEN_DOI: 'NHÂN VIÊN HỖ TRỢ LIÊN ĐỚI',
  },
};

export default CONSTANT;
